export default __webpack_public_path__ + "static/media/Savant'S Ancient Scripts.2bf0c859.jpg";